module.exports = __webpack_public_path__ + "img/avatar_15.48fbcd96.svg";